import { clsx } from 'clsx'
import { forwardRef } from 'react'

import { BigRedButton, type BigRedButtonProps, type BigRedButtonRef } from '@/components'

export type ScreenFooterButtonRef = BigRedButtonRef

export const ScreenFooterButton = forwardRef<BigRedButtonRef, BigRedButtonProps>(
  ({ className, size = 'lg', ...props }, ref) => (
    <BigRedButton
      className={clsx(
        'h-16 flex-1 rounded-xl data-[disabled=true]:bg-brand-orange-500 data-[disabled=true]:opacity-50',
        className
      )}
      ref={ref}
      size={size}
      {...props}
    />
  )
)

ScreenFooterButton.displayName = 'ScreenFooterButton'
